/* Ojasvi: wishlist hearts and AJAX add to cart for forms marked data-type="ojs-add-to-cart". */
(function () {
  if (window.ojsCartInit) return;
  window.ojsCartInit = true;

  var WISH_KEY = 'ojasvi-wishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function paintWishlist() {
    var list = readWishlist();
    document.querySelectorAll('[data-ojs-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.ojsWish) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on);
    });
  }

  window.ojsPaintWishlist = paintWishlist;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintWishlist);
  } else {
    paintWishlist();
  }

  document.addEventListener('click', function (event) {
    var wish = event.target.closest('[data-ojs-wish]');
    if (!wish) return;
    var list = readWishlist();
    var i = list.indexOf(wish.dataset.ojsWish);
    if (i === -1) list.push(wish.dataset.ojsWish);
    else list.splice(i, 1);
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (e) {}
    paintWishlist();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[data-type="ojs-add-to-cart"]')) return;
    // "Buy now" posts normally so Shopify redirects to checkout.
    if (event.submitter && event.submitter.hasAttribute('data-ojs-buy-now')) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || !window.routes || typeof cart.renderContents !== 'function') return;

    event.preventDefault();
    var button = event.submitter || form.querySelector('[type="submit"]');
    button.classList.add('is-loading');

    var body = new FormData(form);
    body.append(
      'sections',
      cart.getSectionsToRender().map(function (section) {
        return section.id;
      })
    );
    body.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          alert(response.description || response.message);
          return;
        }
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        button.classList.remove('is-loading');
      });
  });
})();
